var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlassIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iii_1522_4566)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.0605,
    y: 17.1504,
    width: 5.63477,
    height: 9.15648,
    rx: 2.81738,
    transform: "rotate(-45 13.0605 17.1504)",
    fill: "url(#paint0_linear_1522_4566)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.0605,
    y: 17.1504,
    width: 5.63477,
    height: 9.15648,
    rx: 2.81738,
    transform: "rotate(-45 13.0605 17.1504)",
    fill: "url(#paint1_linear_1522_4566)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.0605,
    y: 17.1504,
    width: 5.63477,
    height: 9.15648,
    rx: 2.81738,
    transform: "rotate(-45 13.0605 17.1504)",
    fill: "url(#paint2_linear_1522_4566)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 13.0605,
    y: 17.1504,
    width: 5.63477,
    height: 9.15648,
    rx: 2.81738,
    transform: "rotate(-45 13.0605 17.1504)",
    fill: "url(#paint3_radial_1522_4566)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.67969 17.8477C14.1584 17.8477 17.7891 14.217 17.7891 9.73828C17.7891 5.25959 14.1584 1.62891 9.67969 1.62891C5.201 1.62891 1.57031 5.25959 1.57031 9.73828C1.57031 14.217 5.201 17.8477 9.67969 17.8477ZM9.67969 16.5352C13.4335 16.5352 16.4766 13.4921 16.4766 9.73828C16.4766 5.98448 13.4335 2.94141 9.67969 2.94141C5.92589 2.94141 2.88281 5.98448 2.88281 9.73828C2.88281 13.4921 5.92589 16.5352 9.67969 16.5352Z",
    fill: "url(#paint4_linear_1522_4566)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1522_4566)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.67989 17.6645C14.0573 17.6645 17.6059 14.1159 17.6059 9.73849C17.6059 5.36108 14.0573 1.8125 9.67989 1.8125C5.30248 1.8125 1.75391 5.36108 1.75391 9.73849C1.75391 14.1159 5.30248 17.6645 9.67989 17.6645ZM9.67989 16.3817C13.3488 16.3817 16.3231 13.4074 16.3231 9.73849C16.3231 6.06958 13.3488 3.09532 9.67989 3.09532C6.01098 3.09532 3.03672 6.06958 3.03672 9.73849C3.03672 13.4074 6.01098 16.3817 9.67989 16.3817Z",
    fill: "url(#paint5_linear_1522_4566)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.67989 17.6645C14.0573 17.6645 17.6059 14.1159 17.6059 9.73849C17.6059 5.36108 14.0573 1.8125 9.67989 1.8125C5.30248 1.8125 1.75391 5.36108 1.75391 9.73849C1.75391 14.1159 5.30248 17.6645 9.67989 17.6645ZM9.67989 16.3817C13.3488 16.3817 16.3231 13.4074 16.3231 9.73849C16.3231 6.06958 13.3488 3.09532 9.67989 3.09532C6.01098 3.09532 3.03672 6.06958 3.03672 9.73849C3.03672 13.4074 6.01098 16.3817 9.67989 16.3817Z",
    fill: "url(#paint6_radial_1522_4566)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1522_4566)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.67979,
    cy: 9.73887,
    r: 6.97129,
    fill: "url(#paint7_linear_1522_4566)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_1522_4566)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.67969,
    cy: 9.73828,
    r: 6.79688,
    fill: "#64D0EA"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.7423,
    cy: 6.33121,
    rx: 1.23843,
    ry: 1.52507,
    transform: "rotate(-38.8957 12.7423 6.33121)",
    fill: "url(#paint8_linear_1522_4566)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iii_1522_4566",
    x: 13.2275,
    y: 14.084,
    width: 9.125,
    height: 9.37305,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4 0 0 0 0 0.239216 0 0 0 0 0.439216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1522_4566"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.639216 0 0 0 0 0.490196 0 0 0 0 0.643137 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1522_4566",
    result: "effect2_innerShadow_1522_4566"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.333333 0 0 0 0 0.27451 0 0 0 0 0.380392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1522_4566",
    result: "effect3_innerShadow_1522_4566"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1522_4566",
    x: 1.45391,
    y: 1.5125,
    width: 16.4521,
    height: 16.4516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15,
    result: "effect1_foregroundBlur_1522_4566"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1522_4566",
    x: 2.5085,
    y: 2.56758,
    width: 14.3424,
    height: 14.3434,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_1522_4566"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_1522_4566",
    x: 2.88281,
    y: 2.79141,
    width: 13.5938,
    height: 14.7438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.603922 0 0 0 0 0.956863 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1522_4566"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.137255 0 0 0 0 0.607843 0 0 0 0 0.984314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1522_4566",
    result: "effect2_innerShadow_1522_4566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1522_4566",
    x1: 13.5329,
    y1: 24.923,
    x2: 16.7811,
    y2: 18.5259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0659C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895792"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1522_4566",
    x1: 15.8696,
    y1: 17.5481,
    x2: 15.8779,
    y2: 20.7633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C3B74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#845590",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1522_4566",
    x1: 18.7699,
    y1: 23.3983,
    x2: 14.9084,
    y2: 23.2823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115168,
    stopColor: "#703D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#703D7A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1522_4566",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.9111 17.0095) rotate(92.4424) scale(1.75002 4.06714)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F1A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532D64",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1522_4566",
    x1: 9.67969,
    y1: 1.62891,
    x2: 9.67969,
    y2: 17.8477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.378529,
    stopColor: "#344A7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633316,
    stopColor: "#785790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837142,
    stopColor: "#785790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9872A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1522_4566",
    x1: 9.67989,
    y1: 1.8125,
    x2: 9.67989,
    y2: 17.6645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4D87"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1522_4566",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.67989 5.55488) rotate(-90.0001) scale(3.84375 7.14842)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.704268,
    stopColor: "#566298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786585,
    stopColor: "#566298",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1522_4566",
    x1: 9.67979,
    y1: 2.76758,
    x2: 9.67979,
    y2: 16.7102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#523573"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1522_4566",
    x1: 12.7423,
    y1: 4.80614,
    x2: 12.7423,
    y2: 7.85628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209118,
    stopColor: "#DCDBF2",
    stopOpacity: 0.84797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDBF2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassIcon);
export default __webpack_public_path__ + "static/media/GlassIcon.efa8d019c420e32b8c425a643467d1c7.svg";
export { ForwardRef as ReactComponent };